import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Promotion } from '@/models';

@Component({
  name: 'CmgRewardQRModal',
})
export default class CmgRewardQRModal extends Vue {
  contentScrolled = false;
  isLoading = false;
  messageText = 'Scan before paying in the restaurant to use this reward.';

  get visible(): boolean {
    return this.$appStore.state.ui.modals.rewardQR.visible;
  }

  get reward(): Promotion {
    return this.$appStore.state.ui.modals.rewardQR.args!.reward!;
  }

  get expirationDateString(): string {
    return this.reward.expirationDate ? `Expires: ${new Date(this.reward.expirationDate).toLocaleDateString('en-US')}` : '';
  }

  onClose() {
    this.$services.ui.setModalVisibility('rewardQR', false);
  }

  onContentScroll({ target: { scrollTop } }: { target: { scrollTop: number } }) {
    this.contentScrolled = scrollTop !== 0;
  }
}
